import { notEquippedUsageUnitAppointmentAccessReasonValueGetter } from '../valueGetter'
import { useTranslation } from 'react-i18next'

const NotEquippedUsageUnitAppointmentAccessRenderer = (props) => {
  const { t } = useTranslation()
  return t(notEquippedUsageUnitAppointmentAccessReasonValueGetter(props))
}

export default NotEquippedUsageUnitAppointmentAccessRenderer
